export const translationFeature = 'dialogMixinTranslations';

export const RequestPasswordResetDialogTranslationKeys = {
  title: 'SMResetPassMail_title',
  pleaseEnterEmail: 'SMResetPassMail_Enter_Email',
  resetPasswordButton: 'dialogMixinTranslations_RESET_PASSWORD_BUTTON',
  email: {
    title: 'SMForm_Email',
    label: 'SMForm_Email',
  },
};
